var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        title: "卡券供应商产品配置-" + _vm.initDetail.supplierName,
        size: "80%",
        direction: "rtl",
        visible: _vm.visibleDrawer,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visibleDrawer = $event
        },
      },
    },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-form",
                {
                  attrs: { inline: "", size: "small", "label-width": "100px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品分类" } },
                    [
                      _c("el-cascader", {
                        staticClass: "selWidth ",
                        attrs: {
                          options: _vm.merCateList,
                          props: _vm.props,
                          clearable: "",
                          size: "small",
                        },
                        on: { change: _vm.handerSearch },
                        model: {
                          value: _vm.listPram.cateId,
                          callback: function ($$v) {
                            _vm.$set(_vm.listPram, "cateId", $$v)
                          },
                          expression: "listPram.cateId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "名称" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "selWidth ",
                          attrs: {
                            placeholder: "名称",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.listPram.skuName,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "skuName", $$v)
                            },
                            expression: "listPram.skuName",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              slot: "append",
                              icon: "el-icon-search",
                              size: "small",
                            },
                            on: { click: _vm.handerSearch },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "SKU编号" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "SKU编号",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.listPram.skuCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "skuCode", $$v)
                            },
                            expression: "listPram.skuCode",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              slot: "append",
                              icon: "el-icon-search",
                              size: "small",
                            },
                            on: { click: _vm.handerSearch },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex-btn" },
                [
                  _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "has-permi",
                              rawName: "v-has-permi",
                              value: ["admin:supplierProduct:saveByIds"],
                              expression: "['admin:supplierProduct:saveByIds']",
                            },
                          ],
                          staticClass: "mr10",
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.addProducts },
                        },
                        [_vm._v("选择商品")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "has-permi",
                              rawName: "v-has-permi",
                              value: ["admin:supplierProduct:import:save"],
                              expression:
                                "['admin:supplierProduct:import:save']",
                            },
                          ],
                          staticClass: "mr10",
                          attrs: { size: "small", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.handlerOpenEdit()
                            },
                          },
                        },
                        [_vm._v("商品导入修改")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "has-permi",
                              rawName: "v-has-permi",
                              value: ["admin:supplierProduct:updateBatch"],
                              expression:
                                "['admin:supplierProduct:updateBatch']",
                            },
                          ],
                          staticClass: "mr10",
                          attrs: {
                            size: "small",
                            type: "primary",
                            disabled: !_vm.selectIds || !_vm.selectIds.length,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.batchAmtEdit()
                            },
                          },
                        },
                        [_vm._v("批量改价")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "has-permi",
                              rawName: "v-has-permi",
                              value: ["admin:supplierProduct:deleteBatch"],
                              expression:
                                "['admin:supplierProduct:deleteBatch']",
                            },
                          ],
                          staticClass: "mr10",
                          attrs: {
                            size: "small",
                            type: "danger",
                            disabled: !_vm.selectIds || !_vm.selectIds.length,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.batchRemove(_vm.selectIds)
                            },
                          },
                        },
                        [_vm._v("批量移除")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "mr10",
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.bindBrand },
                    },
                    [_vm._v("关联品牌")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "skuCode",
                  label: "SKU编码",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "skuName",
                  label: "SKU名称",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "productCateName",
                  label: "分类",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "parPrice", label: "面值" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "deductPrice", label: "扣费信息" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "attrJson",
                  label: "附属参数",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "status",
                  label: "销售状态",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _c("span", {}, [
                        _vm._v(_vm._s({ 1: "正常" }[scope.row.status])),
                      ])
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "180",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:supplierProduct:update"],
                                expression: "['admin:supplierProduct:update']",
                              },
                            ],
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.editProductSetting(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("设置商品信息")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:supplierProduct:delete"],
                                expression: "['admin:supplierProduct:delete']",
                              },
                            ],
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.batchRemove([scope.row.id])
                              },
                            },
                          },
                          [_vm._v("移除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.editDialogConfig.visible,
            title: "产品批量修改",
            top: "60px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.editDialogConfig, "visible", $event)
            },
          },
        },
        [
          _c(
            "el-alert",
            { attrs: { type: "warning", "show-icon": "", closable: false } },
            [
              _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                _vm._v("\n\t\t\t\t\t温馨提示："),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\t\t字段排序为：商品编码、价格类型、对应数值、参数1、参数2、....。"
                ),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\t\t如供应商没有对应产品则忽略改价，对应字段无值则不修改对应字段。\n\t\t\t\t"
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex",
              staticStyle: {
                "margin-top": "20px",
                "align-items": "flex-start",
              },
            },
            [
              _c("div", [_vm._v("文件选择：")]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("uploadFile", {
                    attrs: { accept: ".xlsx, .xls" },
                    model: {
                      value: _vm.editDialogConfig.url,
                      callback: function ($$v) {
                        _vm.$set(_vm.editDialogConfig, "url", $$v)
                      },
                      expression: "editDialogConfig.url",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticStyle: { "margin-top": "8px" } }, [
                    _vm._v("\n\t\t\t\t\t\t必须包含："),
                    _c("br"),
                    _vm._v("\n\t\t\t\t\t\t1: SKU编码"),
                    _c("br"),
                    _vm._v("\n\t\t\t\t\t\t2: 价格形式（参考：1-价格，2-折扣）"),
                    _c("br"),
                    _vm._v("\n\t\t\t\t\t\t3: 对应数值"),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t\t\t4: 额外参数（如果有多个参数的话用英文的逗号','隔开）\n\t\t\t\t\t"
                    ),
                  ]),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editDialogConfig.visible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitImport } },
                [_vm._v("确认修改")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("EditBrank", {
        ref: "editBrankRef",
        on: { doRefresh: _vm.handlerGetListData },
      }),
      _vm._v(" "),
      _c("EditProduct", {
        ref: "editProductRef",
        on: { doRefresh: _vm.handlerGetListData },
      }),
      _vm._v(" "),
      _c("BatchAmt", {
        ref: "batchAmtRef",
        on: { doRefresh: _vm.handlerGetListData },
      }),
      _vm._v(" "),
      _c("SelectProducts", {
        ref: "selectProductsRef",
        attrs: { baseParams: { productType: 2 }, selectType: 2 },
        on: { doRefresh: _vm.handlerGetListData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }